<template>
  <div>
    <v-card
      rounded="sm"
      elevation="2"
      @click="onClickModule(module)"
    >
      <v-card-text class="py-0">
        <v-container>
          <v-row>
            <v-col class="d-flex align-items-center">
              <div class="position-relative pointer-on-hover mr-2"> 
                <img
                  :src="`/images/icons/file_${module.disabled ? 'gray' : 'blue'}_icon.svg`"
                  alt="ciclo"
                  width="24"
                  height="24"
                >
                <span
                  class="position-absolute font-weight-bold font-10"
                  :class="{
                    'theme--text' : !module.disabled
                  }"
                  style="bottom: -8px; left: 3px;"
                  :style="{
                    'color' : module.disabled ? '#d9d9d9': '' 
                  }"
                >
                  {{ module.module_order }}
                </span>
              </div> 
              <v-container>
                <v-row>
                  <v-col
                    class="py-0"
                    md="9"
                  >
                    <p class="mb-2 text-black font-13"> 
                      <span class="font-weight-bold">{{ module.subject_name }}:</span> {{ module.name }}
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    :md="9"
                    :sm="12"
                    :xs="12"
                    class="py-0"
                  >
                    <p class="d-flex align-items-center m-0 font-12">
                      <img
                        src="/images/icons/calendar_gray_icon.svg"
                        alt="calendar"
                        class="mr-1"
                        style="width:14px; height:14px;"
                      >
                      {{ module.begin_at_formatted }} até {{ module.end_at_formatted }}
                    </p> 
                  </v-col>
                  <v-col
                    :md="3"
                    :sm="12"
                    :xs="12"
                    class="py-0 font-12"
                    :style="{ 
                      'color': module.disabled ? '#bdbdbd': '',
                      'min-width': isMobile ? '270px': ''
                    }"
                  >
                    {{ status_text }}
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <div
      v-if="view_plan == 'full'"
      class="mt-2"
    >
      <v-progress-linear
        color="nitro"
        height="10"
        rounded
        class="rounded-pill"
        :value="Math.ceil(module.goal_progress)"
      />
      <div class="d-flex justify-content-between ">
        <div>
          Progresso na meta
        </div>
        <div>
          {{ Math.round(module.goal_progress) }}%
        </div>
      </div>
    </div>
    <div>
      <v-progress-linear
        color="purple"
        height="10"
        rounded
        class="rounded-pill mt-3"
        :value="Math.ceil(module.module_progress)"
      />
      <div class="d-flex justify-content-between text-black ">
        <div>
          Progresso geral
        </div>
        <div>
          {{ Math.round(module.module_progress) }}%
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { showModuleRouteName } from '@/student/constants/routes';
import ModuleOrderImg from '@/student/components/module/content/ModuleOrderImg'

export default {
    components:{
        ModuleOrderImg
    },
      props: {  
        module: {
          type: Object,
          required: true
        },
      },
      computed: {
        ...mapGetters(['view_plan']),
        status_text(){
          if(this.module.finished_at){
            return 'Módulo finalizado';
          }
          if(this.module.disabled){
            return 'Módulo não disponível';
          }else{
            return 'Módulo liberado';
          }
        }
        
      },
      methods: {
        onClickModule(module){
        if(!module.disabled){
            this.$router.push( { name: showModuleRouteName, params: { module_id: module.id }})
            }
        } 
    }
}
</script>